document.addEventListener('DOMContentLoaded', () => {

    let loaded = false;

    function createFooterLogo() {

        if (loaded) return;

        const scrollPosition = window.scrollY + window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        /* Carrega somente quando estiver próximo do rodapé */
        if (scrollPosition < documentHeight - 800) return;

        loaded = true;

        const footer =
            document.querySelector('#shopify-section-footer') ||
            document.querySelector('.footer') ||
            document.querySelector('footer');

        if (!footer) return;

        const wrapper = document.createElement('div');

        wrapper.className = 'footer-logo-showcase';

        wrapper.innerHTML = `
            <div class="footer-logo-showcase__wrapper">

                <div class="footer-logo-showcase__shine">

            <a
            href="/"
            class="footer-logo-showcase__link"
            aria-label="Voltar para página inicial"
            >

                    <img
                        src="${window.footerLogoUrl}"
                        alt="Logo"
                        class="footer-logo-showcase__image"
                        loading="lazy"
                        width="420"
                        height="120"
                    >

                </div>

                </a>

            </div>
        `;

        footer.insertAdjacentElement('afterend', wrapper);

        requestAnimationFrame(() => {

            const logo = wrapper.querySelector('.footer-logo-showcase__image');

            setTimeout(() => {
                logo.classList.add('footer-logo-active');
            }, 100);

        });

        window.removeEventListener('scroll', createFooterLogo);

    }

    window.addEventListener('scroll', createFooterLogo, {
        passive: true
    });

    createFooterLogo();

});